import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { NewHomeProgress } from "./NewHomeProgress";

export const NewHomeBanner = () => (
  <section className="relative overflow-hidden bg-[#1A0B2E] text-white border-b border-[#F5B90A]/30" data-testid="new-home-banner">
    <div className="noise" />
    <div className="container-x relative py-8 md:py-10 grid gap-6 md:grid-cols-12 items-center">
      <div className="md:col-span-5">
        <p className="overline text-[#F5B90A]">Opening December 1, 2026 · Forest Park</p>
        <h2 className="mt-2 font-display text-3xl md:text-4xl font-bold leading-tight">
          Stand behind <span className="text-[#F5B90A]">our new home.</span>
        </h2>
      </div>
      <div className="md:col-span-4">
        <NewHomeProgress compact />
      </div>
      <div className="md:col-span-3 md:text-right">
        <Link to="/new-home" className="btn-gold inline-flex" data-testid="new-home-banner-cta">
          Become a sponsor <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  </section>
);
